import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { toPersianNumber } from "../../utils/persian";

const Quantity = ({ quantity, inc, dec, max, disabled }) => {
  const reachedMax = max && Number(quantity || 0) >= Number(max || 0);

  return (
    <div className="quantity-control">
      <button type="button" onClick={dec} aria-label="کم کردن تعداد" disabled={disabled || Number(quantity || 0) <= 1}>
        <AiOutlineMinus />
      </button>

      <span>{toPersianNumber(quantity)}</span>

      <button type="button" onClick={inc} aria-label="زیاد کردن تعداد" disabled={disabled || reachedMax}>
        <AiOutlinePlus />
      </button>
    </div>
  );
};

export default Quantity;
